// @ts-strict-ignore

import { Editor } from 'slate';
import { MAX_CHARS_POST_BODY, MAX_CHARS_POST_TITLE, MIN_CHARS_EDITOR } from 'src/constants/write';
import { stripBBTags } from 'src/utils/string';
import i18n from 'src/utils/translate';
import { MyEditor } from 'src/components/textEditor/customHelpers';

type ValidateProps = {
  editor?: Editor;
  setIsDirty?: (newState: boolean) => void;
  text?: string; // only used with android editors!
};

export const validateTitle = ({ editor, setIsDirty, text = null }: ValidateProps) => {
  const messages = [];

  const title = editor ? MyEditor.getString(editor, []) : text;
  const cleanTextTitle = !!title.length && stripBBTags(title) || '';
  const trimmedText = cleanTextTitle.trim();

  if (setIsDirty && cleanTextTitle.length > 0) {
    setIsDirty(true);
  }

  switch (true) {
    case (cleanTextTitle?.length === 0 || trimmedText.length === 0): {
      if (setIsDirty) setIsDirty(false);
      messages.push({ text: i18n.t('Title can not be empty') });
      return messages;
    }
    case (cleanTextTitle?.length < MIN_CHARS_EDITOR || trimmedText.length < MIN_CHARS_EDITOR):
      messages.push({ text: i18n.t(`Title must have at least ${MIN_CHARS_EDITOR} characters`) });
      return messages;
    case cleanTextTitle?.length > MAX_CHARS_POST_TITLE:
      messages.push({ text: i18n.t(`Title can have maximum ${MAX_CHARS_POST_TITLE} characters`) });
      return messages;
    default:
      return messages;
  }
};

export const validateBody = ({ editor, setIsDirty, text = null }: ValidateProps) => {
  // emojis count as 2 char.
  const messages = [];

  const post = editor ? MyEditor.getString(editor, []) : text;
  const cleanTextPost = !!post.length && stripBBTags(post) || '';
  const trimmedText = cleanTextPost.trim();

  if (setIsDirty && cleanTextPost.length > 0) {
    setIsDirty(true);
  }

  switch (true) {
    case (cleanTextPost?.length === 0 || trimmedText.length === 0):
      if (setIsDirty) setIsDirty(false);
      messages.push({ text: i18n.t('Body can not be empty') });
      return messages;
    case (cleanTextPost?.length < MIN_CHARS_EDITOR || trimmedText.length < MIN_CHARS_EDITOR):
      messages.push({ text: i18n.t(`Body must have at least ${MIN_CHARS_EDITOR} characters`) });
      return messages;
    case cleanTextPost?.length === MAX_CHARS_POST_BODY:
      messages.push({ text: i18n.t(`You have reached the maximum character limit of ${MAX_CHARS_POST_BODY} characters`), submitAllowed: true });
      return messages;
    case cleanTextPost?.length > MAX_CHARS_POST_BODY:
      messages.push({ text: i18n.t(`Body can have maximum ${MAX_CHARS_POST_BODY} characters`) });
      return messages;
    default:
      return messages;
  }
};
